export function isFileDrag(dataTransfer: DataTransfer): boolean {
  return Array.from(dataTransfer.types).includes("Files")
}

export interface DroppedFiles {
  files: File[]
  folders: File[]
}

export function collectDroppedFiles(dataTransfer: DataTransfer): DroppedFiles {
  const files: File[] = []
  const folders: File[] = []
  for (const item of Array.from(dataTransfer.items)) {
    if (item.kind !== "file") continue
    const entry = item.webkitGetAsEntry()
    if (entry?.isDirectory) {
      folders.push(new File([], entry.name))
      continue
    }
    const file = item.getAsFile()
    if (file !== null) files.push(file)
  }
  return { files, folders }
}
